export const navLinks = [
  { id: "overview", label: "影片概览" },
  { id: "plot", label: "剧情介绍" },
  { id: "review", label: "影评解读" },
  { id: "explain", label: "讲什么" },
  { id: "characters", label: "人物关系" },
  { id: "highlights", label: "看点风格" },
  { id: "impressions", label: "观后感" },
  { id: "related", label: "相关推荐" },
  { id: "faq", label: "常见问答" },
];

export const quickFacts = [
  { icon: "ri-film-line", label: "题材方向", value: "都市 · 情感 · 成年向剧情" },
  { icon: "ri-earth-line", label: "影片地区", value: "韩国情感题材影片" },
  { icon: "ri-links-line", label: "关系核心", value: "姐姐的朋友与主人公" },
  { icon: "ri-compass-3-line", label: "浏览重点", value: "剧情 / 影评 / 解说 / 观后感" },
];

export const overviewInfo = [
  { label: "中文片名", value: "姐姐的朋友电影" },
  { label: "题材类型", value: "都市情感 / 伦理剧情" },
  { label: "语言", value: "韩语" },
  { label: "叙事重心", value: "亲密关系与情感选择" },
  { label: "影像风格", value: "生活化场景 + 暖色调光影" },
  { label: "主要看点", value: "关系张力、氛围营造、节奏推进" },
  { label: "适合观众", value: "偏好成年向情感剧情的观众" },
  { label: "内容提示", value: "属成人题材，建议成年观众理性观看" },
];

export const overviewStats = [
  { value: "3", unit: "条主线", text: "围绕主人公、姐姐、姐姐的朋友展开的关系线索" },
  { value: "5", unit: "个阶段", text: "从相识、升温、冲突到转折与结局的情绪推进" },
  { value: "1", unit: "个主题", text: "在边界与情感之间，人如何做出自己的选择" },
];

export const plotBeats = [
  {
    phase: "01",
    title: "相识与靠近",
    text: "故事从一个看似普通的日常关系展开：主人公因姐姐的社交圈而结识了姐姐的朋友。两人在频繁的接触中逐渐熟悉，从礼貌的寒暄变成更私人的交流，关系在不知不觉中被拉近。",
  },
  {
    phase: "02",
    title: "关系升温",
    text: "随着相处时间增加，双方在情感与边界之间反复试探。影片用大量生活化的场景推进关系，让观众感受到那种介于熟悉与心动之间、说不清道不明的微妙变化。",
  },
  {
    phase: "03",
    title: "冲突浮现",
    text: "当这段关系触碰到现实的边界——家庭、身份、朋友之间的位置与默契，冲突开始显现。人物不得不在情感冲动与现实约束之间反复权衡。",
  },
  {
    phase: "04",
    title: "转折时刻",
    text: "剧情进入转折时，被压抑的情绪与误解被摆上台面，人物关系被迫重新定义。这一阶段是影片情绪最集中、也最考验人物动机的部分。",
  },
  {
    phase: "05",
    title: "结局与余味",
    text: "影片没有给出过于戏剧化的收束，而是留下开放的空间，让人物的选择与遗憾停留在观众心里，也因此成为讨论度较高的部分。",
  },
];

export const reviewAngles = [
  {
    id: "themes",
    label: "主题解读",
    title: "主题解读：边界、距离与被压抑的情绪",
    paragraphs: [
      "如果只看表层情节，这部影片像是一段普通的情感故事；但真正被反复讨论的，是它对“边界”的处理。人物之间的距离感始终在变化，而影片几乎没有用直白的台词去说明，而是让观众从细节里自己体会。",
      "影片真正关心的并不是某一次选择的结果，而是人在面对情感冲动时会暴露出怎样的犹豫与克制。这种克制，恰恰构成了它区别于普通类型片的质感。",
    ],
    points: [
      "关系推进依赖细节而非强情节",
      "情绪表达偏向内敛与留白",
      "冲突来自现实约束而非偶然事件",
      "主题落点在“选择”而非“结果”",
    ],
  },
  {
    id: "narrative",
    label: "叙事结构",
    title: "叙事结构：生活流节奏与情绪递进",
    paragraphs: [
      "影片采用偏向生活流的叙述方式，节奏并不急躁。它把大量时间花在日常场景上，让人物关系在重复的相处中自然生长，这使得情绪递进显得更可信。",
      "这种结构对耐心有一定要求。喜欢快节奏剧情的观众可能会觉得前半段偏慢，但也正是这种“慢”，让后半段的转折更有重量。",
    ],
    points: [
      "前半段以铺垫与关系建立为主",
      "中段通过重复场景累积情绪",
      "后段集中释放矛盾与选择",
      "整体结构呈缓升—急转—留白的曲线",
    ],
  },
  {
    id: "craft",
    label: "表演与氛围",
    title: "表演与氛围：克制之下的张力",
    paragraphs: [
      "在表演上，影片整体偏向克制，人物很少有大开大合的情绪爆发，更多是通过表情、停顿和空间距离来传递状态。这种处理方式让氛围成为叙事的一部分。",
      "配合暖色调的影像与生活化的场景，影片塑造出一种既亲近又疏离的观感，恰好呼应了人物关系本身的不确定。",
    ],
    points: [
      "表演内敛，依靠细节传递情绪",
      "空间与距离被用来表达关系",
      "暖色调强化了日常与怀旧感",
      "声音与配乐多用于渲染氛围",
    ],
  },
  {
    id: "voice",
    label: "口碑视角",
    title: "口碑视角：讨论为何集中在“关系”上",
    paragraphs: [
      "在各类影评与解说中，观众的注意力往往不在情节的曲折，而在人物关系本身。有人从道德角度提出质疑，也有人从情感角度表示理解，讨论本身就构成了这部影片的延伸。",
      "需要说明的是，不同平台的评分会随评价者、时间与统计口径而变化，因此本文不给出固定数值，建议以各平台实时页面为准，并把评分当作参考而非结论。",
    ],
    points: [
      "讨论集中在人物选择是否合理",
      "评价两极与其题材定位有关",
      "评分会随时间浮动，仅供参照",
      "解说类内容多为观众自行创作，风格不一",
    ],
  },
];

export const ratingDimensions = [
  { label: "剧情完成度", value: 78 },
  { label: "情感张力", value: 82 },
  { label: "氛围影像", value: 85 },
  { label: "节奏把控", value: 74 },
  { label: "人物塑造", value: 76 },
];

export const explainerItems = [
  {
    q: "姐姐的朋友电影到底讲了什么？",
    a: "一句话概括，它讲的是主人公因姐姐的社交圈而认识姐姐的朋友，并在日常相处中逐渐产生复杂情感，最终不得不面对现实边界与自我选择的故事。影片重在呈现关系的变化过程，而不是制造反转。",
  },
  {
    q: "故事的主线冲突是什么？",
    a: "主线冲突并非外部事件，而是“情感冲动”与“现实约束”之间的拉扯。家庭关系、朋友之间的默契、以及对关系越界的顾虑，共同构成了人物做选择时的压力来源。",
  },
  {
    q: "主要人物之间的关系如何展开？",
    a: "关系大致经历相识、靠近、升温、冲突与重新定义几个阶段。影片通过重复出现的日常场景来推进，让观众在细节中感受到距离的变化，而不是依赖旁白解释。",
  },
  {
    q: "影片想表达什么主题？",
    a: "它更接近一次关于“边界感”的探讨：当情感与现实发生碰撞时，人会如何权衡。影片没有给出标准答案，而是把判断权交还给观众，这也是它被反复讨论的原因。",
  },
  {
    q: "结尾该怎么理解？",
    a: "结尾偏向开放，没有把人物命运完全说死。这样的处理让遗憾与可能性同时存在，观众往往会根据自己的理解给出不同解读，因此并不存在唯一的“正确结局”。",
  },
  {
    q: "“姐姐的朋友”这个身份有什么意义？",
    a: "这一身份提供了天然的“距离感”：既有亲近的社交基础，又存在不能轻易跨越的边界。正是这种既近又远的位置，让整段关系充满了张力，也决定了故事的基本语气。",
  },
];

export const characters = [
  {
    name: "主人公",
    role: "视角人物",
    desc: "观众大多通过他的视角进入故事。他的犹豫、心动与克制构成叙事的主要动力，也决定了观众的情感落点。",
  },
  {
    name: "姐姐的朋友",
    role: "情感核心",
    desc: "她既是朋友，也是被凝视与被理解的对象。影片围绕她的态度变化推进情绪，她的每次回应都在改变关系的走向。",
  },
  {
    name: "姐姐",
    role: "关系的起点",
    desc: "作为连接各方的角色，姐姐既是主人公生活的背景，也是这段关系得以发生的契机，她的存在让边界问题变得具体。",
  },
  {
    name: "周围关系",
    role: "现实压力",
    desc: "家人、朋友与社交圈的眼光，构成人物做选择时无法回避的现实约束，也是影片冲突得以成立的前提。",
  },
];

export const highlights = [
  {
    icon: "ri-camera-lens-line",
    title: "氛围影像",
    desc: "暖色调与柔和的自然光贯穿全片，营造出贴近日常又略带怀旧感的画面气质。",
  },
  {
    icon: "ri-music-2-line",
    title: "配乐与声音",
    desc: "配乐克制，多用于铺陈情绪而非强调情绪，环境音则增强了生活场景的真实感。",
  },
  {
    icon: "ri-time-line",
    title: "生活流节奏",
    desc: "叙事不急不缓，用重复的日常片段累积情绪，让关系变化显得自然可信。",
  },
  {
    icon: "ri-heart-3-line",
    title: "情感张力",
    desc: "人物很少直接说破心思，张力藏在停顿、眼神与空间距离之中，耐人寻味。",
  },
  {
    icon: "ri-home-smile-line",
    title: "都市日常质感",
    desc: "公寓、厨房、窗边等场景极具烟火气，让成年观众容易产生代入感。",
  },
  {
    icon: "ri-contrast-drop-line",
    title: "光影与色调",
    desc: "偏暖的光影处理强化了亲密与距离的对比，也统一了全片的视觉语言。",
  },
];

export const impressions = [
  {
    tag: "共鸣",
    title: "关于“距离感”的共鸣",
    text: "不少观众表示，最打动自己的不是情节，而是那种“靠得越近反而越小心”的距离感，仿佛看到了现实里似曾相识的犹豫。",
  },
  {
    tag: "遗憾",
    title: "为结局的留白感到遗憾",
    text: "开放式的结尾让一部分观众意难平，也让另一部分观众觉得恰到好处。遗憾本身，成为观后感里出现频率最高的词。",
  },
  {
    tag: "讨论",
    title: "围绕人物选择的争论",
    text: "“这样做对不对”几乎是讨论区绕不开的话题。有人强调现实约束，有人强调情感真实，分歧恰恰说明影片留出了思考空间。",
  },
  {
    tag: "氛围",
    title: "被影像氛围打动",
    text: "也有观众并非被剧情吸引，而是被暖色调的画面与安静的节奏留了下来，认为它更适合在夜里安静地看。",
  },
  {
    tag: "代入",
    title: "从日常场景里看到自己",
    text: "厨房、窗边、深夜的灯这些普通场景，被认为最容易让人代入，因为它们太像真实生活里发生过的片段。",
  },
  {
    tag: "清醒",
    title: "一次关于边界的提醒",
    text: "有观众把它当作一次关于“分寸感”的提醒：情感之外，还需要考虑关系中的位置与他人的感受。",
  },
];

export const relatedDirections = [
  {
    category: "都市情感",
    title: "都市情感题材方向",
    desc: "以城市日常为舞台，聚焦普通人在亲密关系中的靠近与疏远，节奏舒缓、细节密集。",
    tags: ["日常场景", "关系递进", "慢节奏"],
  },
  {
    category: "伦理剧情",
    title: "伦理与选择方向",
    desc: "围绕现实约束下的人物抉择展开，常以开放结局收束，把价值判断留给观众。",
    tags: ["现实压力", "人物抉择", "留白结局"],
  },
  {
    category: "怀旧氛围",
    title: "怀旧氛围方向",
    desc: "以年代质感与暖色调影像见长，用空间与光线唤起记忆感，情绪多藏在画面里。",
    tags: ["年代质感", "暖色调", "都市夜景"],
  },
  {
    category: "氛围影像",
    title: "以氛围见长的作品方向",
    desc: "情节相对淡薄，但依靠光影、配乐与克制表演建立气质，适合偏好沉浸感的观众。",
    tags: ["光影", "配乐", "克制表演"],
  },
  {
    category: "都市情感",
    title: "成年向关系叙事方向",
    desc: "以成年观众为主要受众，讨论亲密关系中的边界与责任，语气冷静而不评判。",
    tags: ["成年视角", "边界感", "冷静叙事"],
  },
  {
    category: "伦理剧情",
    title: "群像关系题材方向",
    desc: "不聚焦单一主角，而是通过多个人物的位置变化来呈现关系网络与情绪流动。",
    tags: ["群像", "关系网络", "情绪流动"],
  },
];

export const faqs = [
  {
    q: "姐姐的朋友电影讲的是什么？",
    a: "核心是一段由日常相处发展而来的复杂情感关系。主人公在姐姐的社交圈中认识姐姐的朋友，并在接触中逐渐产生难以言明的情感，最终面对现实边界与自我选择。影片重点在关系的变化过程，而非情节反转。",
  },
  {
    q: "姐姐的朋友电影豆瓣评分怎么样？",
    a: "不同平台、不同时间点的评分会随评价者与统计口径发生变化，因此本文不给出固定分值。建议以平台实时页面为准，并把评分当作参考信息，结合影片题材与自身偏好来判断是否适合观看。",
  },
  {
    q: "有解说版本吗？解说讲什么？",
    a: "解说类内容多为观众或创作者自行制作，风格与侧重点各不相同，常见的有剧情梳理、主题分析与人物理清。观看时建议保持独立判断，解说仅作为理解影片的一种参考角度。",
  },
  {
    q: "这部影片属于什么类型？",
    a: "整体可归入都市情感与伦理剧情范畴，带有成年向题材的定位。它以生活化场景和克制的情绪表达为主，而不是依靠强情节驱动。",
  },
  {
    q: "适合什么年龄段观看？",
    a: "因其题材与内容定位，更适合成年观众观看。未成年观众建议在成年人的引导下理解其中的情感与伦理议题。",
  },
  {
    q: "在哪里可以看到这部影片？",
    a: "观看渠道会因地区、版权与时间而变化，本文不提供具体链接。建议通过正规、合法的影视平台查询，并遵守当地的相关规定。",
  },
  {
    q: "它是系列电影吗？",
    a: "从常见信息来看，它更接近一部独立的情感题材影片，并非常规意义上的系列作品。若有同名或相似译名，请注意区分不同作品。",
  },
];

export const footerNote =
  "本站为影视信息与影评整理页面，内容为一般性介绍与观点交流，不构成对任何平台或作品的推荐。观影请选择正规、合法的渠道，并保持独立、理性的判断。";